module.exports = __webpack_public_path__ + "static/fonts/iconfont.e9297092.ttf";